import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { getImgFromStr, getDateTimeStamp, getDateDiff } from "../../unit/public";
import { extractLoginData, getAccount } from "../../unit/UserUtil";
import dsteem from "../../unit/DsteemUtil";
export default {
  props: ["communities"],
  components: {},
  name: "community-card",
  data: function data() {
    return {
      loginData: null,
      showLeave: false,
      isJoined: false,
      subscribeLoad: false
    };
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loginData = extractLoginData();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgFromStr: function imgFromStr(json_metadata, body) {
      return getImgFromStr(json_metadata, body);
    },
    dateDiff: function dateDiff(dateTime) {
      return getDateDiff(getDateTimeStamp(dateTime));
    },
    subscribe: function subscribe() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.subscribeLoad = true;
                _this2.loginData = extractLoginData();

                if (_this2.loginData) {
                  _context2.next = 7;
                  break;
                }

                _this2.$bus.emit("openLogin");

                return _context2.abrupt("return");

              case 7:
                _context2.next = 9;
                return dsteem.subscribeCommunity(_this2.communities.name, true);

              case 9:
                result = _context2.sent;
                _this2.isJoined = true;
                _this2.subscribeLoad = false;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    unSubscribe: function unSubscribe() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.subscribeLoad = true;
                _this3.loginData = extractLoginData();

                if (_this3.loginData) {
                  _context3.next = 7;
                  break;
                }

                _this3.$bus.emit("openLogin");

                return _context3.abrupt("return");

              case 7:
                _context3.next = 9;
                return dsteem.subscribeCommunity(_this3.communities.name, false);

              case 9:
                result = _context3.sent;
                _this3.isJoined = false;
                _this3.subscribeLoad = false;

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  computed: {
    link: function link() {
      return "/trending" + "/" + this.communities.name;
    }
  },
  watch: {},
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              /*   let script = document.createElement("script");
              script.type = "text/javascript";
              script.src = "https://static.like.co/sdk/v1/button.js";
              document.body.appendChild(script); */
              _this4.isJoined = _this4.communities.context.subscribed;
              _context4.next = 3;
              return _this4.loadAccount();

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};